import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import api from "../../../../../services/api";
import { Add, Delete } from "@mui/icons-material";
import AlertModal from "../../../../../componentes/alertModal";

export default function EditModalInterfaces(params) {
  const {
    setOpenEditModal,
    openEditModal,
    setSnackbar,
    setLoadingTable,
    styles,
    selectedRow,
    routers,
    handleEditInterfaces,
  } = params;
  const [disableEditButton, setDisableEditButton] = useState(false);
  const [listaIndex, setListaIndex] = useState([""]);
  const [interfaceFlow, setInterfaceFlow] = useState("");
  const [router, setRouter] = useState({});
  //alert modal
  const [confirmarEdicao, setConfirmarEdicao] = useState(false);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && disableEditButton === false) {
      handleApiPutInterfaces();
    }
  };
  const handleChangeIndex = (e, index) => {
    let auxIndex = [...listaIndex];
    auxIndex[index] = e.target.value.replace(/\s/g, "");
    setListaIndex(auxIndex);
  };
  const addIndex = () => {
    setListaIndex([...listaIndex, ""]);
  };
  const removeIndex = (index) => {
    const newIndex = [...listaIndex];
    newIndex.splice(index, 1);
    setListaIndex(newIndex);
  };
  useEffect(() => {
    if (selectedRow) {
      setInterfaceFlow(selectedRow.interface);
      setListaIndex(selectedRow.index ? selectedRow.index?.split(",") : [""]);
      if (routers.length > 0) {
        const routerAux = routers.filter(
          (router) => router?.nome_bgp === selectedRow?.exportador
        );
        if (Array.isArray(routerAux) && routerAux) {
          setRouter(routerAux[0]);
        }
      }
    }
  }, [selectedRow]);
  useEffect(() => {
    if (
      !interfaceFlow ||
      !listaIndex.every((indexValue) => indexValue) ||
      !router
    ) {
      setDisableEditButton(true);
    } else {
      setDisableEditButton(false);
    }
  }, [interfaceFlow, listaIndex, router]);
  async function handleApiPutInterfaces() {
    try {
      setLoadingTable(true);
      setDisableEditButton(true);
      const response = await api.put("/relatoriosFlow/interfaces/update", {
        id: selectedRow.id,
        routerId: router.id,
        interface: interfaceFlow,
        index: listaIndex.join(),
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível salvar dados",
          severity: "error",
        });
      } else {
        setSnackbar({
          children: "Dados Salvos com sucesso",
          severity: "success",
        });
        if (response.data) {
          handleEditInterfaces(response.data);
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Não foi possível se conectar com o servidor",
        severity: "error",
      });
    } finally {
      setLoadingTable(false);
      setDisableEditButton(false);
      setOpenEditModal(false);
      setConfirmarEdicao(false);
      setOpenAlertModal(false);
    }
  }
  return (
    <>
      <Modal
        open={openEditModal}
        onClose={() => {
          setOpenEditModal(false);
        }}
        sx={{ alignItems: "center", justifyContent: "center", display: "flex" }}
      >
        <Paper sx={styles.paperModal} elevation={3}>
          <DialogTitle color="primary">Edite Interfaces </DialogTitle>{" "}
          <DialogContent sx={styles.dialogContent}>
            <Stack direction="row" spacing={"20px"} sx={{ mt: 1 }}>
              <FormControl sx={{ width: "100%" }}>
                <InputLabel>Exportador</InputLabel>
                <Select
                  value={router}
                  label="Exportador"
                  onChange={(event) => {
                    setRouter(event.target.value);
                  }}
                >
                  {routers?.map((router, index) => (
                    <MenuItem key={index} value={router}>
                      {router.nome_bgp ? router.nome_bgp : "Indefinido"}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>{" "}
            </Stack>
            <Stack direction="column" spacing={"20px"}>
              <TextField
                sx={styles.TextField}
                id="textfield-interface"
                label="Interface"
                onKeyDown={handleKeyDown}
                value={interfaceFlow}
                onChange={(e) =>
                  setInterfaceFlow(e.target.value.replace(/\s/g, ""))
                }
              />
              {listaIndex?.map((indexValue, index) => (
                <Stack direction="row" key={index}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="textfield-lista-index"
                    label={"Index " + (index + 1)}
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={indexValue}
                    onChange={(event) => handleChangeIndex(event, index)}
                  />{" "}
                  {listaIndex.length > 1 && (
                    <IconButton
                      onClick={() => removeIndex(index)}
                      sx={{ mr: -1 }}
                    >
                      <Delete color="secondary" />
                    </IconButton>
                  )}
                  <IconButton
                    size="small"
                    onClick={addIndex}
                    sx={{ ml: 1, mr: -1 }}
                  >
                    <Add color="primary" />
                  </IconButton>
                </Stack>
              ))}
              {/* <TextField
                sx={styles.TextField}
                id="textfield-index"
                label="Index"
                
                type="number"
                value={index}
                onChange={(e) => setListaIndex(e.target.value)}
              />*/}
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              onClick={() => {
                setOpenEditModal(false);
              }}
            >
              Cancelar
            </Button>
            <Button
              disabled={disableEditButton}
              onClick={() => {
                setOpenAlertModal(true);
                // handleApiPutInterfaces();
              }}
            >
              Editar
            </Button>
          </DialogActions>
        </Paper>
      </Modal>
      <AlertModal
        openModal={openAlertModal}
        setOpenModal={setOpenAlertModal}
        confirmar={confirmarEdicao}
        handleButton={handleApiPutInterfaces}
        severity={"warning"}
        singleButton={false}
      />
    </>
  );
}
